
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class Book extends Vue {
  created (): void {
    const domain = this.$route.params.domain

    if (!domain) {
      return
    }

    const query = window.location.search

    window.location.replace(
      `https://book.frontlinesystems.no/${domain}/book${query}`
    )
  }
}
